module.exports = {
      id: "checkbox-unchecked-icon-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#checkbox-unchecked-icon",
      toString: function () {
        return this.url;
      }
    }